import { BoxProps } from '../BoxNew'
import { ImageProps } from '../ImageNew'
import { TextProps } from '../TextNew'

const defaultStyles = {
  topContainerStyle: {
    alignContent: 'center',
    justifyContent: 'center',
  } as BoxProps,
  topTextStyle: {
    fontSize: 'FONT_SIZE_LARGE_PLUS',
    fontWeight: '500',
    textAlign: 'center',
    color: 'BLACK_75',
    marginVertical: 8,
    marginHorizontal: 24,
  } as TextProps,
  containerLogo: {
    marginTop: 36,
    alignSelf: 'center',
    height: 72,
    width: 72,
    borderColor: 'GREY_SEPARATOR',
    backgroundColor: 'WHITE',
    borderWidth: 1,
    borderRadius: 72 / 2,
    overflow: 'hidden',
  } as BoxProps,
  logo: {
    height: 72,
    width: 72,
  } as ImageProps,
  placeHolderText: {
    color: 'WHITE',
    fontWeight: 'FONT_WEIGHT_LIGHT',
    fontSize: 30,
  } as TextProps,
  placeHolderContainer: {
    height: '100%',
    width: '100%',
    backgroundColor: 'PRIMARY',
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
}

const logoTypes = {
  huge: {
    ...defaultStyles,
  },
  small: {
    ...defaultStyles,
    containerLogo: {
      alignSelf: 'center',
      height: 24,
      width: 24,
      borderColor: 'GREY_SEPARATOR',
      backgroundColor: 'WHITE',
      borderWidth: 1,
      borderRadius: 24 / 2,
      overflow: 'hidden',
    } as BoxProps,
    logo: {
      height: 24,
      width: 24,
    } as ImageProps,
    placeHolderText: {
      color: 'WHITE',
      fontWeight: 'FONT_WEIGHT_LIGHT',
      fontSize: 10,
    } as TextProps,
  },
  medium: {
    ...defaultStyles,
    containerLogo: {
      alignSelf: 'center',
      height: 36,
      width: 36,
      borderColor: 'GREY_SEPARATOR',
      backgroundColor: 'WHITE',
      borderWidth: 1,
      borderRadius: 36 / 2,
      overflow: 'hidden',
    } as BoxProps,
    logo: {
      height: 36,
      width: 36,
    } as ImageProps,
    placeHolderText: {
      color: 'WHITE',
      fontWeight: 'FONT_WEIGHT_LIGHT',
      fontSize: 15,
    } as TextProps,
  },
  medium30: {
    ...defaultStyles,
    containerLogo: {
      alignSelf: 'center',
      height: 30,
      width: 30,
      borderColor: 'GREY_SEPARATOR',
      backgroundColor: 'GRAY_SHADOW',
      borderWidth: 1,
      borderRadius: 30 / 2,
      overflow: 'hidden',
    } as BoxProps,
    logo: {
      height: 30,
      width: 30,
    } as ImageProps,
    placeHolderText: {
      color: 'WHITE',
      fontWeight: 'FONT_WEIGHT_LIGHT',
      fontSize: 13,
    } as TextProps,
  },
  large: {
    ...defaultStyles,
    containerLogo: {
      alignSelf: 'center',
      height: 54,
      width: 54,
      borderColor: 'GREY_SEPARATOR',
      backgroundColor: 'WHITE',
      borderWidth: 1,
      borderRadius: 54 / 2,
      overflow: 'hidden',
    } as BoxProps,
    logo: {
      height: 54,
      width: 54,
    } as ImageProps,
    placeHolderText: {
      color: 'WHITE',
      fontWeight: 'FONT_WEIGHT_LIGHT',
      fontSize: 20,
    } as TextProps,
  },
}

export { logoTypes }
